import cn from 'classnames';

import { IconAlertTriangle } from 'components/UI/Icons';
import type { InvoiceStatusSeverity } from 'helpers/invoiceStatus';

/**
 * Non-blocking overdue-invoice warning banner (admin-facing). Plain Tailwind —
 * intentionally not the antd/theme-ui `Alert`. Color follows the worst
 * severity among the statuses being warned about.
 */
export function InvoiceOverdueBanner({
  children,
  className,
  severity = 'amber',
}: {
  children: React.ReactNode;
  className?: string;
  severity?: InvoiceStatusSeverity;
}) {
  return (
    <div
      className={cn(
        'text-13 flex items-center gap-x-2 rounded-[8px] p-3',
        severity === 'red'
          ? 'bg-red-50 text-red-800'
          : 'bg-yellow-50 text-yellow-800',
        className,
      )}
      role="status"
    >
      <span className="flex h-4 w-4 shrink-0 items-center justify-center">
        <IconAlertTriangle />
      </span>
      <span>{children}</span>
    </div>
  );
}
